import { Component, Input } from '@angular/core';
import { AppEventModel, HxEventService } from 'hx-services';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Component of invoice event list
 */
@Component({
    selector: 'hc-invoice-events',
    templateUrl: './invoice-events.component.html',
    styleUrls: ['./invoice-events.component.css'],
    imports: [NgIf, NgFor, NgClass, DatePipe, TranslocoPipe]
})
export class InvoiceEventsComponent {
  events: AppEventModel[] = [];
  invoiceEventList = {
    'INVOICE_NEW': {
      badge: 'brand'
    },
    'INVOICE_SENT': {
      badge: 'success'
    },
    'INVOICE_SHIPMENT': {
      badge: 'warning'
    },
    'INVOICE_ACCEPTED': {
      badge: 'info'
    },
    'INVOICE_CANCELLED': {
      badge: 'danger'
    },
    'INVOICE_REJECTED': {
      badge: 'danger'
    },
    'INVOICE_DISCARDED': {
      badge: 'focus'
    },
    'INVOICE_RESTORED': {
      badge: 'brand'
    }
  };

  @Input()
  set id(val: number) {
    if (val) {
      this.loadEvents(val);
    }
  }

  isLoading = {
    list: false,
  };

  constructor(
    private eventService: HxEventService,
  ) {
  }

  private loadEvents(id: number) {
    this.isLoading.list = true;
    this.eventService.getInvoiceEventList(id).then(result => {
      this.events = result;
      this.isLoading.list = false;
    }, err => {
      this.isLoading.list = false;
    });
  }

}
